import { fetchURL, fetchJSON, StatusError } from './utils'

export async function changePassword(current: string, password: string) {
  const data = new FormData()
  data.append('current', current)
  data.append('password', password)

  const res = await fetchURL(`/api/auth/change-password`, {
    method: 'POST',
    body: data,
  })

  return res.ok
}

export async function get(id: number) {
  return fetchJSON<IUser>(`/api/auth/${id}`, {})
}

export async function create(user: IUser) {
  const res = await fetchURL(`/api/auth`, {
    method: 'POST',
    body: JSON.stringify(user),
    headers: {
      'Content-Type': 'application/json',
    },
  })

  if (res.status === 201) {
    return res.headers.get('Location')
  }

  throw new StatusError(await res.text(), res.status)
}

export async function update(user: IUser) {
  await fetchURL(`/api/auth/account`, {
    method: 'PUT',
    body: JSON.stringify(user),
    headers: {
      'Content-Type': 'application/json',
    },
  })
}
